import { h, Component } from "preact";
import { connect } from "react-redux";

import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
import CardLogos from "../../components/CardLogos";

import {
  pay,
  payClicked,
  checkoutError
} from "../../state/actions/orderActions";
import { loadCheckOutScript } from "../../state/actions/stripeActions";

import ZipMoney from "./ZipMoney";
import { css } from "emotion";

import config from "../../config";

const nextStageButton = css({ height: "40px !important", minWidth: 150 });

class PaymentStripe extends Component {
  constructor() {
    super();
    this.initCheckout = this.initCheckout.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.stripe = null;
    this.card = null;
  }

  componentDidMount() {
    const { stripe, loadCheckOutScript } = this.props;
    if (!stripe.checkoutScript.loaded && !stripe.checkoutScript.loading) {
      loadCheckOutScript();
    } else {
      this.initCheckout();
    }
  }

  componentDidUpdate(prevProps) {
    const { orderId, stripe, loadCheckOutScript } = this.props;
    if (
      !prevProps.stripe.checkoutScript.loaded &&
      stripe.checkoutScript.loaded
    ) {
      this.initCheckout();
    }
  }

  initCheckout() {
    const { gateway } = this.props;
    // Create a Stripe client.
    this.stripe =
      gateway === "stripe"
        ? Stripe(config("STRIPE_APK_KEY"))
        : Stripe(config("STRIPE_PAYMENTS_APK_KEY"));
    // Create an instance of Elements.
    const elements = this.stripe.elements();
    // Custom styling
    const style = {
      base: {
        color: "#32325d",
        lineHeight: "18px",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };
    // Create an instance of the card Element.
    this.card = elements.create("card", { style: style });
    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount("#card-element");
    // Handle real-time validation errors from the card Element.
    this.card.addEventListener("change", function(event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });
  }

  handleSubmit(evt) {
    const {
      event,
      pay,
      payClicked,
      checkoutError,
      slug,
      orderId,
      gateway,
      isGlobal,
      order
    } = this.props;
    evt.preventDefault();
    payClicked();
    this.stripe.createToken(this.card).then(function(result) {
      if (result.error) {
        // Inform the user if there was an error.
        var errorElement = document.getElementById("card-errors");
        errorElement.textContent = result.error.message;
        checkoutError();
      } else {
        if (isGlobal) {
          // Send the token to your server. stripeTokenHandler(result.token);
          pay(
            slug,
            orderId,
            gateway,
            { token: result.token.id },
            order.userId,
            true
          );
        } else {
          const eventId = event.data._id;
          // Send the token to your server. stripeTokenHandler(result.token);
          pay(slug, orderId, gateway, { token: result.token.id }, eventId);
        }
      }
    });
  }

  render({ event, order, stripe, isGlobal }) {
    if (order.paymentRequest.error) {
      window.scrollTo(0, 0);
    }
    const error = order.paymentRequest.error;
    return (
      <div>
        <p>
          All transactions are secure and encrypted. Payment information is
          never stored.
        </p>
        {error ? <p class="text-error">{error}</p> : ""}
        {!stripe.checkoutScript.loaded || stripe.checkoutScript.loading ? (
          <div class="loading loading-lg" />
        ) : !order.timeExpired ? (
          <form onSubmit={this.handleSubmit}>
            <div
              class="form-group"
              style={{
                margin: "30px 0"
              }}
            >
              <label class="form-label" for="form-label">
                Credit or debit card
              </label>
              <div id="card-element" />
              <div id="card-errors" role="alert" />
            </div>
            <ZipMoney />
            <ActionBar>
              <ActionButton
                disabled={
                  order.waitingToPay ||
                  order.paymentRequest.loading ||
                  order.timeExpired
                }
                loading={order.waitingToPay || order.paymentRequest.loading}
                classNames={nextStageButton}
              >
                Pay Now
              </ActionButton>
              <CardLogos event={event} isGlobal={isGlobal} />
            </ActionBar>
          </form>
        ) : null}
      </div>
    );
  }
}
export default connect(
  state => ({ event: state.event, order: state.order, stripe: state.stripe }),
  { loadCheckOutScript, pay, payClicked, checkoutError }
)(PaymentStripe);



// WEBPACK FOOTER //
// ./routes/payment/PaymentStripe.js